import { createContext } from 'react';
import { useDefinedContext } from '@/src/utils/context/useDefinedContext';
import { NotificationsStore } from '@/src/features/app/store/notifications/store';

export const NotificationsContext = createContext<NotificationsStore | undefined>(undefined);

export const useNotificationsContext = (): NotificationsStore => useDefinedContext(NotificationsContext);
